import { render } from "./quadro.vue?vue&type=template&id=688491aa&scoped=true"
import script from "./quadro.vue?vue&type=script&lang=js"
export * from "./quadro.vue?vue&type=script&lang=js"

import "./quadro.vue?vue&type=style&index=0&id=688491aa&scoped=true&lang=css"

import exportComponent from "/var/deploy/staging2/web_head/releases/20251210221730/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688491aa"]])

export default __exports__